<template>
  <v-footer color="primary lighten-1">
    <v-row justify="center" no-gutters>
      <div>
        <v-btn
          v-for="link in $t('app.footerLinks')"
          :key="link"
          color="white"
          @click="$router.push(link.route)"
          text
          rounded
          class="my-2"
        >{{ link.label }}</v-btn>
      </div>

      <v-col class="primary lighten-1 text-center white--text" cols="12">
        <v-card-text class="white--text pt-0">
{{$t('app.footer_text')}}
 <p>
          <a class="white--text" href="mailto:contact@fattoura.com">contact@fattoura.com</a>
        </p>
      </v-card-text>
       
        {{ new Date().getFullYear() }} —
        <strong>Fattoura.com</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  name: "FooterBar",
  components: {},
  data() {
    return {

    };
  },
  methods: {}
};
</script>

<style scoped>
@media print {
  footer {
    height: 0 !important;
    display: none !important;
  }
}
</style>